var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('speaker',{staticClass:"event-speaker_popup-profile",attrs:{"always-full":true,"userIconSize":50,"use-job":true,"show-profile-link-btn":true,"speaker":_vm.speaker}})}
var staticRenderFns = []

export { render, staticRenderFns }